<div [formGroup]="formGroup" *ngIf="formGroup">
  <mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <input
      type="text"
      matInput
      [placeholder]="placeHolder"
      [attr.aria-label]="label"
      [formControl]="customControl"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="optionSelected($event)"
    >
      <mat-option *ngFor="let option of filteredOptions" [value]="getOptionValue(option)">
        {{ getOptionText(option) }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
